import React, { createContext } from 'react';

// Create a context to share projects data across the app
export const ProjectsContext = createContext();

// Provider component that wraps the app
export const ProjectsProvider = ({ children, projects }) => {
  return (
    <ProjectsContext.Provider value={projects}>
      {children}
    </ProjectsContext.Provider>
  );
};
